'use client';
import React from 'react';
import { TasticProps } from '../types';
import { Props } from '../blog/types';
import LandingPageCardSection from '@/components/organisms/landing-page-card';

const LandingPageCardSectionTastic = ({ data }: TasticProps<Props>) => {

    return (
        <LandingPageCardSection data={data}/>
    );
};

export default LandingPageCardSectionTastic;
